<template>
    <base-nav class="navbar-top navbar-dark "
              id="navbar-main"
              :show-toggle-button="true"
              expand>

        <ul class="navbar-nav align-items-center d-md-flex">
            <li class="nav-item">
             <router-link class="nav-link" to="/">
                 <span>Trang Chủ</span>
             </router-link>
            </li>
            <li class="nav-item">
             <router-link class="nav-link" to="/events">
                 <span>Ca Trực</span>
             </router-link>
            </li>
            <li class="nav-item">
               <router-link class="nav-link" to="/organizations">
                <span>Khách Hàng</span>
                </router-link>         
            </li>
                        <li class="nav-item dropdown mr-0">
                <base-dropdown class="nav-link pr-0">
                     <div class="media align-items-center" slot="title">
                         <div class="media-body ml-2  d-lg-block">
                            <span class="mb-0 text-sm  font-weight-bold">Công Cụ</span>
                        </div>
                     </div>
                        <template>
                        <router-link class="dropdown-item" to="/tools/board">
                            <i class="ni ni-calendar-grid-58"></i>
                            <span>Bảng</span>
                        </router-link>
                        <router-link class="dropdown-item" to="/tools/nwdevice">
                            <i class="ni ni-ui-04"></i>
                            <span>Quản lý Port</span>
                        </router-link>
                        </template>
                        <a href="https://1drv.ms/x/s!AiJZPw_f-VZeg_EGr3S3jbpfxaeavg?e=cH16wt">
                            <font color="212529">
                            <i class="ni ni-vector"></i>
                            <span>Tài nguyên SFP</span>
                            </font>
                        </a>
                </base-dropdown>
            </li>
            <li class="nav-item dropdown mr-0" v-if="isAdmin">
                <base-dropdown class="nav-link pr-0">
                     <div class="media align-items-center" slot="title">
                         <div class="media-body ml-2 d-lg-block">
                            <span class="mb-0 text-sm  font-weight-bold">Quản Lý</span>
                        </div>
                     </div>
                        <template>
                        <router-link class="dropdown-item" to="/management/users">
                            <i class="ni ni-single-02"></i>
                            <span>Tài Khoản</span>
                        </router-link>
                        <div class="dropdown-divider"></div>
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Ca Trực</h6>
                        </div>
                        <router-link class="dropdown-item"  to="/management/canon">
                            <i class="ni ni-bullet-list-67"></i>
                            <span>Tiêu Chí</span>
                         </router-link>
                         <router-link class="dropdown-item"  to="/management/report">
                            <i class="ni ni-chart-pie-35"></i>
                            <span>Thống Kê</span>
                         </router-link>
                        </template>
                </base-dropdown>
            </li>
        </ul>
        <div class="navbar-search navbar-search-dark form-inline mr-3  d-md-flex ml-lg-auto">
        </div>
        <ul class="navbar-nav align-items-center d-md-flex">
            <li class="nav-item dropdown mr-0">
                <base-dropdown class="nav-link pr-0">
                    <div class="media align-items-center" slot="title">
                <span class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="img/theme/user-icon.png">
                </span>
                        <div class="media-body ml-2 d-none d-lg-block">
                            <span class="mb-0 text-sm  font-weight-bold">{{curuser}}</span>
                        </div>
                    </div>

                    <template>
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Xin chào!</h6>
                        </div>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-settings-gear-65"></i>
                            <span>Cài đặt</span>
                        </router-link>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-support-16"></i>
                            <span>Hỗ trợ</span>
                        </router-link>
                        <div class="dropdown-divider"></div>
                        <base-button @click="logout" class="dropdown-item">
                            <i class="ni ni-user-run"></i>
                            <span>Thoát</span>
                        </base-button>
                    </template>
                </base-dropdown>
            </li>
        </ul>
    </base-nav>
</template>
<script>
  export default {
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchQuery: ''
      };
    },
    methods: {
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      async logout() {
          await localStorage.removeItem('token')
          let token = ''
          let user = {}
          await this.$store.dispatch('update_success', token)
          await this.$store.dispatch('update_user', user)
          await this.$router.push('/login')
      }
    },
    computed: {
        curuser() {
            return this.$store.state.user.username
        },
        isAdmin() {
            return this.$store.getters.is_admin
        }
    }
  };
</script>
